import { FC } from 'react';
import styles from './BackButton.module.scss';
import { TextButton, TextButtonProps } from 'wix-style-react';
import { LeftColorArrow } from 'src/redesign/assets/icons/arrows';

export const BackButton: FC<TextButtonProps> = (props) => {
  return (
    <TextButton {...props} className={styles.button} prefixIcon={<LeftColorArrow />}>
      {props.children}
    </TextButton>
  );
};
